<template>
  <div class="avatar">
    <img v-if="src" :src="src" :alt="alt" loading="lazy" decoding="async" />
    <slot v-else />
  </div>
</template>

<script>
export default {
  name: 'UIAvatar',
  props: {
    src: { type: String, default: '' },
    alt: { type: String, default: 'avatar' }
  }
}
</script>

<style scoped>
</style>


